import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    loaderContainer: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        backgroundColor: 'white',
        opacity: 0.5,
        display: 'grid',
        placeItems: 'center',
    },
    loaderCirc: {
        zIndex: 10000,
        color: theme.palette.grey[600],
    },
}))

const LoaderApp = () => {
    const classes = useStyles()

    return (
        <div className={classes.loaderContainer}>
            <CircularProgress id="LoaderApp" size={80} className={classes.loaderCirc} />
        </div>
    )
}

export default LoaderApp